(function () {
  var $modalLogin;

  var $conf = $('.js-config');
  $modalLogin = $('.js-modal-login');
  var $globalConfData = $('.js-conf-global-data');
  var $facebookPixelEnable = $globalConfData.data('facebookpixel-enable') ? $globalConfData.data('facebookpixel-enable').toLowerCase() == "true" : false;

  $("#btnRegisterCV").bind("click", function () {
    if ($facebookPixelEnable) {
      fbq('track', 'ViewContent');
    }
  });

  $("#btnRegisterCVHome").bind("click", function () {
    if ($facebookPixelEnable) {
      fbq('track', 'ViewContent');
    }
  });
})();
